import Image from "next/image"
import Head from "next/head";
import upscbanner1 from "../../assets/images/home/Banner/UPSC-result-web-banner-2026.jpg";
// import phone from "../../assets/images/upsc/phone.png";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const  Interest = dynamic(()=>import("../../components/might-be-interest"));
const  Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const  BranchAddress = dynamic(()=>import("../../components/branch-address"));
const  ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-form";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import Link from "next/link";
import useDownloader from "react-use-downloader";
import downloadicon from "../../assets/images/download.png";
import Emioption from "../../components/Service/emioption";
import Optionalplus from "../../components/Service/optionalplus";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
const UPSCClassroomOnline = () => {

  const [selectedBranch, setSelectedBranch] = useState("Tamil Nadu");
  const {download} = useDownloader();   
  const fileUrl = "/pdf/SIA-Brochure-2025_Trivandrum.pdf";
  const filename = "SIA-Brochure-2025_Trivandrum.pdf"

  const feestructure =[
    
    {date:"18.06.2026", cont:"Regular", cont1:"09:00 am to 02:00 pm"},

    // {date:"24.04.2026", cont:"Regular", cont1:"09:00 am to 02:00 pm"},
    // {date:"26.06.2026", cont:"Regular", cont1:"09:00 am to 02:00 pm"},
    
  ]

  const feestructure2 =[
    {date:"15.06.2026",cont:"Weekend",cont1:"09:00 am to 01:00 pm"},
  
  ]

  
  const feestructure3 =[
    {date:"04.07.2026",cont:"Weekend",cont1:"PSIR",cont2:"09:00 am to 01:00 pm"},
    {date:"04.07.2026",cont:"Weekend",cont1:"Mathematics",cont2:"08:30 am to 01:30 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2026",cont:"Weekend",cont1:"Tamil literature",cont2:"09:00 am to 01:00 pm"},
    {date:"12.07.2026",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"25.07.2026",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"01.08.2026",cont:"Weekend",cont1:"Economics",cont2:"09:00 am to 01:00 pm"},
    
    {date:"06.07.2026",cont:"Regular",cont1:"Anthropology",cont2:"02:30 pm to 04:30 pm"},
    {date:"20.07.2026",cont:"Regular",cont1:"Agriculture",cont2:"06:30 pm to 08:30 pm"},
    {date:"24.07.2026",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"14.08.2026",cont:"Regular",cont1:"English",cont2:"02:30 pm to 05:00 pm"},
    {date:"14.09.2026",cont:"Regular",cont1:"Law",cont2:"02:30 pm to 05:00 pm"}
   
    
     
  ]

  const jsonLd ={
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "IAS Academy in Trivandrum | Shankar IAS Academy",
        "url": "https://www.shankariasacademy.com/thiruvananthapuram/",
        "Image":
        "https://www.shankariasacademy.com/_next/static/media/Pre-book-2024_Webbanner-Without-button.6686241b.webp",
        "description": "Premier IAS Academy in Trivandrum offering expert coaching for civil service aspirants. Join us for comprehensive training & guidance."
  }
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Navigated to ${url}`);
      router.reload(); // Refresh the page on route change
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    // Cleanup on component unmount
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

    const getBranchName = () => {
    switch (router.pathname) {
      case "/adyar":
        return "Adyar";
      case "/trichy":
        return "Trichy";
      case "/salem":
        return "Salem";
      case "/madurai":
        return "Madurai";
      case "/coimbatore":
        return "Coimbatore";
      case "/upsc-admission-anna-nagar":
        return "Tamil Nadu";
      default:
        return "Tamil Nadu";
    }
};

  const branches = [
    
    { name: "Bengaluru", path: "/bengaluru" },
    { name: "Delhi", path: "/delhi" },
    { name: "Hyderabad", path: "/hyderabad" },
    // { name: "Bhubaneswar", path: "/bhubaneswar" },
    { name: "Thiruvananthapuram", path: "/thiruvananthapuram" },
    { name: "Online Class", path: "/upsc-online-class" },
    { name: "NRI", path: "/upsc-admission-nri" },

  ];


    return (
      <>

        <Head>
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>IAS Academy in Trivandrum | Shankar IAS Academy</title>
            <meta name="title" content="IAS Academy in Trivandrum | Shankar IAS Academy" />
            <meta name="description" content="Premier IAS Academy in Trivandrum offering expert coaching for civil service aspirants. Join us for comprehensive training & guidance." />
            <link rel="canonical" href="https://www.shankariasacademy.com/thiruvananthapuram/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="IAS Academy in Trivandrum | Shankar IAS Academy" />
            <meta property="og:description" content="Premier IAS Academy in Trivandrum offering expert coaching for civil service aspirants. Join us for comprehensive training & guidance." />
            <meta property="og:url" content="https://www.shankariasacademy.com/thiruvananthapuram/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>

          <Navbar title="upsc" />

          <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 pt-3 pt-md-4">

              {/* Desktop View */}
              <div className={`${styles.tabscrollclass} ${styles.desktopView}`}>

                <div className={styles.dropdown}>
                  <span className={styles.tamilNaduBtn}>
                    {getBranchName()}
                  </span>

                  <ul className={styles.dropdownmenu}>
                    <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                    <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                    <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                    <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                    <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                    <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                  </ul>
                </div>

                {branches.map((branch) => (
                  <Link key={branch.path} href={branch.path}>
                    <button
                      className={
                        router.pathname === branch.path
                          ? styles.activeBranch
                          : styles.normalBranch
                      }
                    >
                      {branch.name}
                    </button>
                  </Link>
                ))}
              </div>

              {/* Mobile & Tablet View */}
              <div className={styles.mobileView}>

                <div className={styles.dropdown}>
                  <span className={styles.tamilNaduBtn}>
                    {getBranchName()}
                  </span>

                  <ul className={styles.dropdownmenu}>
                    <li><Link href="/upsc-admission-anna-nagar" className={styles.dropdownitem}>Anna Nagar</Link></li>
                    <li><Link href="/adyar" className={styles.dropdownitem}>Adyar</Link></li>
                    <li><Link href="/coimbatore" className={styles.dropdownitem}>Coimbatore</Link></li>
                    <li><Link href="/trichy" className={styles.dropdownitem}>Trichy</Link></li>
                    <li><Link href="/salem" className={styles.dropdownitem}>Salem</Link></li>
                    <li><Link href="/madurai" className={styles.dropdownitem}>Madurai</Link></li>
                  </ul>
                </div>

                {branches.map((branch) => (
                  <Link key={branch.path} href={branch.path}>
                    <button
                      className={
                        router.pathname === branch.path
                          ? styles.activeBranch
                          : styles.normalBranch
                      }
                    >
                      {branch.name}
                    </button>
                  </Link>
                ))}
              </div>

            </div>
          </div>
          </div>

           

                {/* <div className="container">
                    <div className="row">
                       <div className="col pt-3 pt-md-4">
                            <div className={`${styles.tabscrollclass} nav nav-pills align-items-baseline`}>
                                <Link href="/upsc-admission-anna-nagar"><button id={styles.tablinks} className="nav-link tab1 py-2 px-0 me-4 " type="button">Anna Nagar</button></Link>
                                <Link href="/adyar"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Adyar</button></Link>
                                <Link href="/bengaluru"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Bengaluru</button></Link>
                                <Link href="/coimbatore"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Coimbatore</button></Link>
                                <Link href="/delhi"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Delhi</button></Link>
                                <Link href="/hyderabad"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Hyderabad</button></Link>
                                <Link href="/thiruvananthapuram"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4 active" type="button">Thiruvananthapuram</button></Link>
                                <Link href="/trichy"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Trichy</button></Link>
                                <Link href="/salem"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Salem</button></Link>
                                <Link href="/madurai"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">Madurai</button></Link>
                                <Link href="/upsc-online-class"><button id={styles.tablinks} className="nav-link tab10 py-2 px-0 me-4" type="button">Online Class</button></Link>
                                <Link href="/upsc-admission-nri"><button id={styles.tablinks} className="nav-link py-2 px-0 me-4" type="button">NRI</button></Link>
                            </div>
                        </div>
                    </div>
                </div> */}
               
                <div className="container">
                    <div className="row">
                        <div className="col pt-4 pt-md-4">
                            <h1 className={`${styles.pagemaintitle}`}>UPSC - Classroom & Online - Thiruvananthapuram</h1>
                            <Image
                              src={upscbanner1}
                              className="img-fluid w-100 pt-2"
                              alt="Classroom and online coaching"
                              title="Classroom and online coaching"
                            />
                        </div>
                    </div>
                </div>

{/* <Classroom_form branchname="Thiruvananthapuram"/> */}

<div className="container pb-5">
  <div className={`${styles.coursesimg} mb-2`}>
      <div class="col-12 col-md-6 offset-md-3 mt-4">
          <p className={`${styles.contactheader} text-center`}>Enquiry</p>
          <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
          <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
      </div>
  </div>
</div>

  <div className="container-fluid">
        <div className={`${styles.bestbg1}`}>
          <div className="row g-4 mt-2">
            <div className="col-12 col-md-6 col-lg-12">
              <div className="card shadow-sm p-4">
                <h2> <span style={{fontSize:"20px",color:'#db1b0d' ,fontWeight:"bold"}}>Pre Booking Open</span></h2> 
                <p>
                  For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>79949 36555 | 75919 02600.</span> 
                </p>
                <div className={`${styles.brochure} justify-content-center`}>
                  <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-thiruvananthapuram-admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                      <button className={`${styles.normalbutton1} btn btn-danger`}>
                      <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                      </button>
                  </a>
                </div>
              </div>
            </div>   
          </div>
        </div>
    </div>

{/* Fee Details Section */}

<div className="container">
  <div className="row pt-2">
    {/* <div className={`${styles.brochure}`}>
      <h2 className={`${styles.sectiontitle} pt-3`}>Course and Fees</h2>
      <button className={`${styles.normalbutton2} ${styles.brochurebtn}`} onClick={() => download(fileUrl, filename)}>
        <Image src={downloadicon} alt="download icon" />
        <p className={`${styles.brochuretxt}`}>Download Brochure</p>
      </button>
    </div> */}
    
    <div className="col-xl-6 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.facultyborder3} col-lg-6`}>
            <p className={`${styles.sectionsubtitle} mb-0 mx-3 pb-3`}>GSPCM & CSAT Fees (Both included)</p>
           
            <span className={`${styles.acheiverrank}  mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>70,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span>
          </div>
          <div className={`${styles.facultyborder3} col-lg-6 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>

        <div className="pt-3">       
          <div className="row mx-auto">
              <div className="col ps-0">
                  <table className="table ">
                    <tbody>
                    {feestructure.map((item,index)=>(
                      <tr key={index}>
                        <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                        <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                        <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                      </tr>
                      ))}
                    </tbody>
                  </table>
              </div>
          </div>
        </div>

        <div className=" mb-3 mb-md-4 col-12">
          <div className="row p-2">
            <div className={`${styles.csatborder} col-6 col-lg-6 p-3`}>
                <p className={`${styles.sectionsubtitle} mb-2 mx-3`}>CSAT</p>
                {/* <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b> 15,000</span><span style={{verticalAlign: "top"}}>(inclusive of tax)</span></span> */}
            </div>

            <div className={`${styles.csatborder} col-6 col-lg-6 pt-4 md-pt-4`} >
                <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
            </div>
          </div>

          <div className="pt-3">       
            <div className="row mx-auto">
              <div className="col ps-0">
              <table className="table ">
                <tbody>
                {feestructure2.map((item,index)=>(
                  <tr key={index}>
                    <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                    <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                  </tr>
                  ))}
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
    </div>
    
     

    <div className="col-xl-6 col-lg-6 mb-3 mb-md-4 col-12">
        <div className="row p-2">
          <div className={`${styles.facultyborder3} col-6 col-lg-8`}>
              <div className="p-3">
                <p className={`${styles.sectionsubtitle} mb-2 mx-3`}>Optional</p>
                <span className={`${styles.acheiverrank} mx-3`}> <span className={`${styles.sectionredtitle} pe-1`}><b>₹</b>30,000</span></span>
              </div>
          </div>

          <div className={`${styles.facultyborder3} col-6 col-lg-4 pt-4`} >
            <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.gsbutton}`}>Pay Here</button></a>
          </div>
        </div>

        <div className="pt-3">       
            <div className="row mx-auto">
              <div className="col ps-0 ps-xl-0 p-xl-0">
                  <div className="table-responsive text-nowrap">
                    <table className="table">
                      <tbody>
                      {feestructure3.map((item,index)=>(
                        <tr key={index}>
                          <td className={`${styles.classacheiverrank} mb-0`}>{item.date}</td>
                          <td className={`${styles.classacheiverrank} mb-0`}>{item.cont}</td>
                          <td className={`${styles.classacheiverrank} mb-0`}>{item.cont1}</td>
                          <td className={`${styles.classacheiverrank} mb-0`}>{item.cont2}</td>
                        </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
              </div>
            </div>
        </div>         
    </div>

    <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
      <ObtionalButton />
    </div>
           
    <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12">
          <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
          <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12 py-2">
          <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle}`}><b>₹</b>1,00,000*</span><span>(inclusive of tax)</span></span>
        </div> 
        <div className="col-xl-3 col-lg-4 col-md-6 col-12 p-2  text-right">
          <Emioption />  
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
          <a href="https://admissionsv1.shankariasacademy.com/?center=TRIVANDRUM&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
        </div>
    </div>
  </div>
</div>

<div className={`${styles.sadhana}`}>
    <div class="container">
      <div className="row">
        <div className="col-12 offset-md-4 col-md-4 p-2">
          <Link href="/two-year-upsc-program">
             <Image alt="sadhana" className="img-fluid" src={sadhana} />
          </Link>
        </div>   
      </div>
    </div>
</div>

<Program_Features />

{/* Our Acheivers */}
<div className="container">
  <div className="row">
    <div className="col pt-4 pt-md-5 text-center">
       <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
        <p className={`${styles.sectionsubtitle}`}>
          Rank Holders from our academy
        </p>
    </div>
  </div>
</div>

<Acheiver />

<section id="toppers">
  <div className="container">
    <div className="row">
      <div className="  col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
        <Optionalplus /> 
      </div>
    </div>
  </div>
</section>


<div className="container">   
  <div className="row pt-3">
    <div className="col">
      <p className={`${styles.sectionsubtitle} mb-2`}>Best IAS Academy in Thiruvananthapuram | UPSC Coaching Center in Thiruvananthapuram | Shankar IAS Academy</p>
      
      <p className={`${styles.acheiverrank}`}>Shankar IAS Academy, the best IAS Academy in Thiruvananthapuram , offers the best classes for UPSC Coaching in Thiruvananthapuram, 
         India. With step by step guidance from our trainers, the students will learn the top tricks to clear the examinations and make the IAS study simple. 
         Superior and dedicated faculties, unique and innovative learning methodologies, and focus on the right techniques are few unique features that make our 
         students clear the exam at the first attempt.
      </p>
      <
        p className={`${styles.acheiverrank}`}>Successful actions and decisions help in reaching the goal. Having this in mind, we at 
          Shankar IAS Academy took the best steps on providing the best education to our students. We offer them vast knowledge and subject 
          lessons to make them the best IAS aspirant as well as a good human being to serve people.
      </p>
      <p className={`${styles.acheiverrank}`}>Shankar IAS Academy is the top-notch IAS Coaching Centre in Thiruvananthapuram incorporated in 2004 by Mr. Shankar. 
        D, a post-graduate in Agriculture. Most of the students prefer Shankar IAS Academy, among other best IAS Coaching in Thiruvananthapuram, 
        as we act as an excellent eye-opener for each of our aspirants. Our student results speak of who Shankar IAS Academy is in Thiruvananthapuram. 
        Our students have seen 100% clearance in IAS exams for the past five years and proved the quality and effort of the best UPSC Coaching in Thiruvananthapuram.
      </p>
      <p className={`${styles.sectionsubtitle} mb-2`}>Why are we the most unique UPSC Coaching Centre in Thiruvananthapuram?</p>

      <ul>
          <li className={`${styles.acheiverrank}`}>A team of experienced and well-trained faculty members hand-picked from various institutions and Universities.</li>
          <li className={`${styles.acheiverrank}`}>We make our students stick to the syllabus with Interactive and participatory learning methodology.</li>
          <li className={`${styles.acheiverrank}`}>We offer 360-degree guidance which includes comprehensive coverage of the complete syllabus (updated) , current affairs,prelims test series, main test series, interview guidance, and more.</li>
          <li className={`${styles.acheiverrank}`}>The information and knowledge imparted by the best Civil Service Coaching Centre in Thiruvananthapuram will help students clear not just UPSC CSE but also other competitive exams like Indian Forest Services, SSC etc.</li>
          <li className={`${styles.acheiverrank}`}>The excellent team effort of our ambitious academy has led to the success of our IAS Academy in Thiruvananthapuram.</li>
          <li className={`${styles.acheiverrank}`}>Having a limited number of batches and good student faculty ratio has enabled us to provide equal attention to every student of Shankar IAS Academy.</li>
      </ul>
        <p className={`${styles.sectionsubtitle} mb-2`}>Why are we the best-quality UPSC Coaching Centre in Thiruvananthapuram?</p>
      <ul>
          <li className={`${styles.acheiverrank}`}>The best IAS Coaching in Thiruvananthapuram for students who have a higher appetite for knowledge and a great attitude.</li>
          <li className={`${styles.acheiverrank}`}>Our Classes are taken by Enthusiastic and dedicated faculty members for the best results.</li>
          <li className={`${styles.acheiverrank}`}>We have the most updated and carefully selected IAS study materials.</li>
          <li className={`${styles.acheiverrank}`}>Comprehensive training and education is provided to the students as per the pace of changes happening in the exam.</li>
      </ul>
    </div>
  </div>
</div>

  <BranchAddress />
  <Interest />
  <Footer />                        
      </>
    )
  }
  
  export default UPSCClassroomOnline;
